module.exports = __webpack_public_path__ + "static/media/skins.2c0e825c.svg";